import React, { type FC, type ReactNode } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "../lib/auth/AuthContext";
import { GlobalProvider } from "./AppContextProvider";
interface ProviderProp {
  children: ReactNode;
}
const AppProviders: FC<ProviderProp> = ({ children }): JSX.Element => {
  return (
    <Router>
      <AuthProvider>
        <GlobalProvider>{children}</GlobalProvider>
      </AuthProvider>
    </Router>
  );
};
export default AppProviders;
